import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    variablesAll: (context, botId) => {
        axios.defaults.withCredentials = true
        let url = constConf.scenarios.url + '/variables/all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.type === 'AllResult') {
                    context.commit('variablesAll', response.response.data)
                } else {
                    context.commit('variablesAll', [])
                }
            // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get all' + error)
            })
    },
    variablesListsAll: (context, botId) => {
        axios.defaults.withCredentials = true
        let url = constConf.scenarios.url + '/variables-lists/all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.type === 'AllResult') {
                    context.commit('variablesListsAll', response.response.data)
                } else {
                    context.commit('variablesListsAll', [])
                }
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get all' + error)
            })
    },
    variableCreate: (context, data) => {
        let method = 'post'
        let url = constConf.scenarios.url + '/variables/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.scenarios.url + '/variables/update/' + data.id
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                let functionName = { put: 'setVariable', post: 'addVariable' }
                context.commit(functionName[method], response.response.data)
                return response
            })
    },
    variableDelete: (context, id) => {
        let url = constConf.scenarios.url + '/variables/delete/' + id
        return context.dispatch('axios/query', { url: url, method: 'delete' }, { root: true })
            .then(response => {
                /* if (response.type === 'DeleteResult') {
                    context.commit('variableDelete', response.response.data)
                } */
                return response
            })
    },
    changeBotIdModelDefault: (context, botId) => {
        context.commit('changeBotIdModelDefault', botId)
    },
    saveVariablesList: (context, data) => {
        let method = 'post'
        let url = constConf.scenarios.url + '/variables-lists/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.scenarios.url + '/variables-lists/update/' + data.id
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                let functionName = { put: 'setVariablesList', post: 'addVariablesList' }
                context.commit(functionName[method], response.response.data)
                return response
            })
    },
    deleteVariablesList: (context, id) => {
        let url = constConf.scenarios.url + '/message-lists/delete/' + id
        return context.dispatch('axios/query', { url: url, method: 'delete' }, { root: true })
            .then(response => {
                if (response.type === 'DeleteResult') {
                    context.commit('deleteVariablesList', response.response.data)
                }
                return response
            })
    },
    variableClientUpdate: (context, model) => {
        let url = constConf.scenarios.url + '/variables-clients/update/' + model.id
        return context.dispatch('axios/queryWithData', { url: url, method: 'put', data: model }, { root: true })
            .then(response => {
                if (response.type === 'UpdateResult') {
                    context.commit('variablesClientUpdate', response.response.data)
                }
                return response
            })
    },
    variablesClientAll: (context, model) => {
        let url = constConf.scenarios.url + '/variables-clients/all/' + model.user_id
        return context.dispatch('axios/query', { url: url, method: 'get' }, { root: true })
            .then(response => {
                if (response.type === 'AllResult') {
                    context.commit('variablesClientAll', response.response.data)
                }
                return response.response
            })
    }
}
